/* eslint-disable no-restricted-imports */
import React, {useMemo} from 'react'
import styles from './DiceStats.module.scss'
import {useUIGameEndContext} from '../../../../../contexts/UIGameEndContext'
import {BarChart} from '../../BarChart'
import {T} from '../../../../../common/T'
import {CA} from '../../../../../../../../code/client/shared/scripts/analytics/Analytics'
import {socket} from '../../../../../../../../code/client/shared/scripts/EntryShared'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../../../../../code/shared/entity_datas/EntityDatas'
import {useUIGameMyColorContext} from '../../../../../contexts/UIGameMyColorContext'
import {useUIGameReplayContext} from '../../../../../contexts/UIGameReplayContext'

export const DiceStats = () => {
    const {gameEndData} = useUIGameEndContext()
    const {myColor} = useUIGameMyColorContext()
    const {isReplay} = useUIGameReplayContext()

    const chartData = useMemo(() => gameEndData.endGameState.diceStats.map((item, index) => ({
        label: index + 2,
        value: item,
        barClassName: index + 2 === 7 ? styles.grayBar : null,
    })), [gameEndData])

    const onClickWasDiceUnfair = () => {
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.EndGameWasDiceUnfair,
            category: AnalyticEventCategory.Game,
            dimensions: {
                playerColor: myColor,
                gameId: socket.gameListener.databaseGameId,
            },
        })
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.title}>
                    <T id={{key: 'strings:game.endGame.dice.rolls'}}/>
                </div>
                {isReplay === false && <div className={styles.wasDiceUnfair}>
                    <a href="https://blog.colonist.io/balanced-dice-designing/" onClick={onClickWasDiceUnfair} rel="noreferrer" target="_blank">
                        <T id={{key: 'strings:game.endGame.footer.wasDiceUnfair'}} />
                    </a>
                </div>}
            </div>
            <BarChart chartData={chartData}/>
        </div>
    )
}
